import * as React from 'react';
import { Box } from "@mui/system"
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress } from "@mui/material";
import { send_authorized_request } from '../../Constants/cognito'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { AXIOS_API_INSTANCE, RENTAL_CONTRACT_COLOR_MAP, RENTAL_STATUS_FRIENDLY_NAMES } from '../../Constants';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import dayjs from "dayjs"

export default function ContractHistoryAccordion({ rental_item_id, disabled }) {
    const [contractItems, setContractItems] = React.useState(undefined)
    const [isLoading, setIsLoading] = React.useState(true)

    const getContractItems = () => {
        setIsLoading(true)
        let filterVar = {
            "rental_item_id.eq": rental_item_id
        }
        const pageSize = 10
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalcontractitems", {
                        params: {
                            page_num: contractItems?.page || 0,
                            page_size: pageSize,
                            order_by: "estimated_start_date",
                            order_by_direction: "desc",
                            filters: JSON.stringify(filterVar),
                        },
                    }),
                ])
                .then(
                    axios.spread((newContractItems) => {
                        console.log(newContractItems)
                        setContractItems({
                            rows: (contractItems?.rows || []).concat(newContractItems.data.data),
                            total_count: newContractItems.data.total_count,
                            page: (contractItems?.page || 0) + 1
                        })
                        setIsLoading(false)
                    })
                )
        )
    }

    const get_startdate = (item) => {
        return dayjs.utc(item.start_date ?? item.estimated_start_date).local().format('M/D/YYYY h:mm A')
    }
    const get_startdateicon = (item) => {
        if(item.start_date){
            return undefined
        } else {
            return <AccessTimeIcon sx={{ height: '22px', verticalAlign: 'text-bottom' }} />
        }
    }
    const get_enddate = (item) => {
        return dayjs.utc(item.end_date ?? item.estimated_end_date).local().format('M/D/YYYY h:mm A')
    }
    const get_enddateicon = (item) => {
        if(item.end_date){
            return undefined
        } else {
            return <AccessTimeIcon sx={{ height: '22px', verticalAlign: 'text-bottom' }} />
        }
    }

    React.useEffect(() => {
        if (contractItems === undefined) {
            getContractItems()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractItems])

    return (<Accordion disabled={disabled}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="contractItems-content"
            id="contractItems-header"
        >
            <Typography>Contract History</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <Box>
                {
                    (contractItems?.rows || []).map((item) => {
                        return (
                            <Button href={`/Contracts/${item.rental_contract_id}`} color={RENTAL_CONTRACT_COLOR_MAP[item.status] || 'primary'} variant='contained' key={item.id} sx={{ m:1, p: 1, justifyContent: 'start', width: '100%', borderRadius: 2, boxShadow: 3, fontSize: '20px' }}>
                                <span><b>{RENTAL_STATUS_FRIENDLY_NAMES[item.status]} ({get_startdateicon(item)}{get_startdate(item)} - {get_enddateicon(item)}{get_enddate(item)})</b></span>
                            </Button>
                        )
                    })
                }
                {isLoading &&
                    <Box>
                        <CircularProgress />
                        <p>Getting more Contracts</p>
                    </Box>
                }
                <Button variant='contained' disabled={isLoading || contractItems.rows.length === contractItems.total_count} onClick={getContractItems}>Get More Contracts ({contractItems?.rows?.length}/{contractItems?.total_count})</Button>
            </Box>
        </AccordionDetails>
    </Accordion>)
}